import $ from 'jquery';
import carousels from '../framework/carousel';

if ($('#champions-slider').length) {
  const championsSlider = carousels('[data-carousel="champions-slider"]', {
    autoplay: false,
    dots: false,
    infinite: true,
    speed: 500,
    arrows: true,
    slidesToShow: 4,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 578,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
}
